export function isLocalUrl(url: string) {
  return /^\/[^/]/.test(url);
}

// technically would return true for /......./, which should be an invalid traversal,
// however it's still suspicious, so we'll consider it an attempt at traversal
export function includesDirectoryTraversal(url: string) {
  return /\/\.+\//.test(url);
}

export function isSafeForRedirect(url: string) {
  return isLocalUrl(url) && !includesDirectoryTraversal(url);
}
